import { Modal, ModalBody, ModalFooter } from "shared/UI/Modal/Modal";
import { t } from "i18next";
import { handleCopy } from "core/helpers/copy";
import Button from "shared/UI/Buttons/Button";
import { useNotifyModalContext } from "shared/core/state/NotifyModalContext/NotifyModalContext";

export type InviteModalProps = {
  code: string;
  onClose: Function;
};

export const InviteModal = ({ code, onClose }: InviteModalProps) => {
  const { modalNotify } = useNotifyModalContext();

  function copy() {
    handleCopy(code);
    modalNotify("success", t("leaderboards.invite.copied"));
    onClose();
  }

  return (
    <Modal width="xs" title={t("leaderboards.invite.heading")} hideDismiss close={() => { }}>
      <ModalBody>
        <div role="note">{t("leaderboards.invite.text")}</div>
        <div role="main" className="text-code text-center mt-6">
          {code}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button text={t("leaderboards.invite.buttons.copy")} onClick={() => copy()} />
        <Button variant="text" text={t("leaderboards.invite.buttons.back")} onClick={() => onClose()} />
      </ModalFooter>
    </Modal>
  );
};
